// extracted by mini-css-extract-plugin
export var reviews = "style-mod--reviews--41788";
export var reviewsCardContainer = "style-mod--reviews-card-container--e2fc8";
export var reviewsDescription = "style-mod--reviews-description--9e332";
export var reviewsImage = "style-mod--reviews-image--b2d48";
export var reviewsName = "style-mod--reviews-name--db867";
export var reviewsSlide = "style-mod--reviews-slide--c2b4f";
export var reviewsSlider = "style-mod--reviews-slider--d1118";
export var reviewsStars = "style-mod--reviews-stars--fd603";
export var reviewsTitle = "style-mod--reviews-title--afec8";